<template>
    <div class="container mb-8 mx-auto px-4">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">
            {{ __('Korábbi rendelések') }}
        </h1>
    </div>

    <div class="bg-white px-2 w-full" v-if="products">
        <div class="bg-highlight flex items-center justify-between px-2 py-4 text-white">
            <a class="cursor-pointer flex items-center text-lg text-white uppercase"
               v-if="order?.previous_order"
               v-on:click="prevOrder"
            >
                <c-icon class="h-6 mr-2 stroke-white w-6" icon="chevron-left" />
                <span class="hidden landscape:sm:inline">{{ __('Előző') }}
            </span>
            </a>
            <span class="landscape:sm:w-[90px] w-[32px]" v-else>&nbsp;</span>
            <span class="font-serif hidden text-3xl landscape:sm:inline">
                {{ __(':week. hét', { week: currentWeek }) }} <small class="font-sans text-base">({{ currentYear }})</small>
            </span>
            <span class="font-serif text-3xl landscape:sm:hidden">
                {{ DateTime.fromISO(currentDate).toFormat(localizationStore.dateFormat) }}
            </span>
            <a class="cursor-pointer flex items-center text-lg text-white uppercase"
               v-if="order?.next_order && (order.next_order.year != DateTime.now().weekYear || order?.next_order.week != DateTime.now().weekNumber)"
               v-on:click="nextOrder"
            >
                <span class="hidden landscape:sm:inline">{{ __('Következő') }}</span>
                <c-icon class="h-6 ml-2 stroke-white w-6" icon="chevron-right" />
            </a>
            <span class="landscape:sm:w-[135px] w-[32px]" v-else>&nbsp;</span>
        </div>
        <div class="grid grid-cols-5 font-semibold px-2 text-center landscape:sm:grid-cols-9 xl:grid-cols-10">
            <span class="flex items-center justify-center p-4 landscape:sm:hidden xl:flex"></span>
            <span class="border-l col-span-2 flex items-center justify-center p-4 landscape:sm:col-span-3">
                {{ __('Termék') }}
            </span>
            <span class="border-l hidden items-center justify-center p-4 landscape:sm:flex">
                {{ __('Ár') }}
            </span>
            <span class="border-l col-span-2 hidden p-4 landscape:sm:col-span-1 landscape:sm:block"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'monday' }"
            >
                {{ __('Hétfő') }}<br />
                <span class="hidden landscape:sm:block">{{ currentDays.monday.month }} {{ currentDays.monday.day }}</span>
            </span>
            <span class="border-l col-span-2 hidden p-4 landscape:sm:col-span-1 landscape:sm:block"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'tuesday' }"
            >
                {{ __('Kedd') }}
                <span class="hidden landscape:sm:block">{{ currentDays.tuesday.month }} {{ currentDays.tuesday.day }}</span>
            </span>
            <span class="border-l col-span-2 hidden p-4 landscape:sm:col-span-1 landscape:sm:block"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'wednesday' }"
            >
                {{ __('Szerda') }}
                <span class="hidden landscape:sm:block">{{ currentDays.wednesday.month }} {{ currentDays.wednesday.day }}</span>
            </span>
            <span class="border-l col-span-2 hidden p-4 landscape:sm:col-span-1 landscape:sm:block"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'thursday' }"
            >
                {{ __('Csütörtök') }}
                <span class="hidden landscape:sm:block">{{ currentDays.thursday.month }} {{ currentDays.thursday.day }}</span>
            </span>
            <span class="border-l col-span-2 hidden p-4 landscape:sm:col-span-1 landscape:sm:block"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'friday' }"
            >
                {{ __('Péntek') }}
                <span class="hidden landscape:sm:block">{{ currentDays.friday.month }} {{ currentDays.friday.day }}</span>
            </span>
        </div>
        <div v-for="product in products">
            <div class="border-t grid grid-cols-5 px-2 landscape:sm:grid-cols-9 xl:grid-cols-10"
                 v-if="showProduct(product, currentYear + '.' + currentWeek)"
            >
                <span class="flex items-center justify-center p-1 landscape:sm:hidden xl:flex">
                    <img class="max-w-32 w-full" v-bind:alt="product.name" v-bind:src="product.picture" />
                </span>
                <span class="border-l col-span-2 flex flex-col items-start justify-center p-4 landscape:sm:col-span-3">
                    <strong class="block text-slate-800 text-sm">{{ product.name }}</strong>
                    <span class="mt-1 text-slate-500 text-xs">{{ product.description }}</span>

                    <div class="flex flex-col landscape:sm:hidden" v-if="product.prices[`${user.group_id}`]">
                        <span class="mt-4">
                            {{ currencyStore.format(product.prices[`${user.group_id}`], 'huf') }}
                        </span>

                        <span class="text-xs" v-if="product.prices[`${user.group_id}`]">
                            ({{ currencyStore.format(product.prices[`${user.group_id}`] / (1 + product.vat_pct / 100), 'huf') }} + {{ __('ÁFA') }})
                        </span>
                    </div>
                    <div class="flex flex-col landscape:sm:hidden" v-else>
                        <span class="mt-4">
                            {{ currencyStore.format(product.price_gross, 'huf') }}
                        </span>

                        <span class="text-xs">
                            ({{ currencyStore.format(product.price_gross / (1 + product.vat_pct / 100), 'huf') }} + {{ __('ÁFA') }})
                        </span>
                    </div>
                </span>
                <span class="border-l hidden items-center justify-center p-4 text-center landscape:sm:flex">
                    <div class="flex flex-col" v-if="product.prices[`${user.group_id}`]">
                        <span>
                            {{ currencyStore.format(product.prices[`${user.group_id}`], 'huf') }}
                        </span>

                        <span class="text-xs">
                            ({{ currencyStore.format(product.prices[`${user.group_id}`] / (1 + product.vat_pct / 100), 'huf') }} + {{ __('ÁFA') }})
                        </span>
                    </div>
                    <div class="flex flex-col" v-else>
                        <span>{{ currencyStore.format(product.price_gross, 'huf') }}</span>

                        <span class="text-xs">
                            ({{ currencyStore.format(product.price_gross / (1 + product.vat_pct / 100), 'huf') }} + {{ __('ÁFA') }})
                        </span>
                    </div>
                </span>
                <span class="border-l col-span-2 flex-col hidden items-center justify-center p-4 landscape:sm:col-span-1 landscape:sm:flex"
                      v-bind:class="{ '!flex' : currentDate.weekdayLong.toLowerCase() === 'monday' }"
                >
                    <div class="flex items-center">
                        <span class="block border-2 border-highlight flex items-center h-12 justify-center mx-3 rounded-full text-2xl text-center w-12"
                              v-if="product.quantity[`${currentYear}.${currentWeek}`].monday > 0"
                        >
                            {{ product.quantity[`${currentYear}.${currentWeek}`].monday }}
                        </span>
                    </div>
                </span>
                <span class="border-l col-span-2 flex-col hidden items-center justify-center p-4 landscape:sm:col-span-1 landscape:sm:flex"
                      v-bind:class="{ '!flex' : currentDate.weekdayLong.toLowerCase() === 'tuesday' }"
                >

                    <div class="flex items-center">
                        <span class="block border-2 border-highlight flex items-center h-12 justify-center mx-3 rounded-full text-2xl text-center w-12"
                              v-if="product.quantity[`${currentYear}.${currentWeek}`].tuesday > 0"
                        >
                            {{ product.quantity[`${currentYear}.${currentWeek}`].tuesday }}
                        </span>
                    </div>
                </span>
                <span class="border-l col-span-2 flex-col hidden items-center justify-center p-4 landscape:sm:col-span-1 landscape:sm:flex"
                             v-bind:class="{ '!flex' : currentDate.weekdayLong.toLowerCase() === 'wednesday' }"
            >

                    <div class="flex items-center">
                        <span class="block border-2 border-highlight flex items-center h-12 justify-center mx-3 rounded-full text-2xl text-center w-12"
                              v-if="product.quantity[`${currentYear}.${currentWeek}`].wednesday > 0"
                        >
                            {{ product.quantity[`${currentYear}.${currentWeek}`].wednesday }}
                        </span>
                    </div>
                </span>
                <span class="border-l col-span-2 flex-col hidden items-center justify-center p-4 landscape:sm:col-span-1 landscape:sm:flex"
                             v-bind:class="{ '!flex' : currentDate.weekdayLong.toLowerCase() === 'thursday' }"
            >

                    <div class="flex items-center">
                        <span class="block border-2 border-highlight flex items-center h-12 justify-center mx-3 rounded-full text-2xl text-center w-12"
                              v-if="product.quantity[`${currentYear}.${currentWeek}`].thursday > 0"
                        >
                            {{ product.quantity[`${currentYear}.${currentWeek}`].thursday }}
                        </span>
                    </div>
                </span>
                <span class="border-l col-span-2 flex-col hidden items-center justify-center p-4 landscape:sm:col-span-1 landscape:sm:flex"
                             v-bind:class="{ '!flex' : currentDate.weekdayLong.toLowerCase() === 'friday' }"
            >

                    <div class="flex items-center">
                        <span class="block border-2 border-highlight flex items-center h-12 justify-center mx-3 rounded-full text-2xl text-center w-12"
                              v-if="product.quantity[`${currentYear}.${currentWeek}`].friday > 0"
                        >
                            {{ product.quantity[`${currentYear}.${currentWeek}`].friday }}
                        </span>
                    </div>
                </span>
            </div>
        </div>
        <div class="font-bold py-4 text-center"
             v-if="!hasAvailableProducts(currentYear + '.' + currentWeek)"
        >
            {{ __('Nem történt rendelés ezen a héten.') }}
        </div>

        <div class="bg-highlight font-semibold grid grid-cols-5 items-center mt-4 px-2 text-xl text-center text-white uppercase landscape:sm:grid-cols-9 xl:grid-cols-10">
            <span class="col-span-3 px-4 py-2 landscape:sm:col-span-4 xl:col-span-5">{{ __('Összesen') }}</span>
            <span class="border-l border-l-white col-span-2 hidden px-4 py-2 landscape:sm:block landscape:sm:col-span-1"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'monday' }"
            >
                {{ currencyStore.format(totalPrice.monday.gross, 'huf') }}
                <span class="block text-xs" v-if="totalPrice.monday.net">
                    {{ currencyStore.format(totalPrice.monday.net, 'huf') }} + {{ __('ÁFA') }}
                </span>
            </span>
            <span class="border-l border-l-white col-span-2 hidden px-4 py-2 landscape:sm:block landscape:sm:col-span-1"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'tuesday' }"
            >
                {{ currencyStore.format(totalPrice.tuesday.gross, 'huf') }}
                <span class="block text-xs" v-if="totalPrice.tuesday.net">
                    {{ currencyStore.format(totalPrice.tuesday.net, 'huf') }} + {{ __('ÁFA') }}
                </span>
            </span>
            <span class="border-l border-l-white col-span-2 hidden px-4 py-2 landscape:sm:block landscape:sm:col-span-1"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'wednesday' }"
            >
                {{ currencyStore.format(totalPrice.wednesday.gross, 'huf') }}
                <span class="block text-xs" v-if="totalPrice.wednesday.net">
                    {{ currencyStore.format(totalPrice.wednesday.net, 'huf') }} + {{ __('ÁFA') }}
                </span>
            </span>
            <span class="border-l border-l-white col-span-2 hidden px-4 py-2 landscape:sm:block landscape:sm:col-span-1"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'thursday' }"
            >
                {{ currencyStore.format(totalPrice.thursday.gross, 'huf') }}
                <span class="block text-xs" v-if="totalPrice.thursday.net">
                    {{ currencyStore.format(totalPrice.thursday.net, 'huf') }} + {{ __('ÁFA') }}
                </span>
            </span>
            <span class="border-l border-l-white col-span-2 hidden px-4 py-2 landscape:sm:block landscape:sm:col-span-1"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'friday' }"
            >
                {{ currencyStore.format(totalPrice.friday.gross, 'huf') }}
                <span class="block text-xs" v-if="totalPrice.friday.net">
                    {{ currencyStore.format(totalPrice.friday.net, 'huf') }} + {{ __('ÁFA') }}
                </span>
            </span>
        </div>
    </div>

    <c-button class="bg-slate-800 border-2 border-slate-800 font-semibold hover:bg-highlight hover:border-highlight landscape:sm:w-96 mt-8 mx-auto normal-case px-4 py-2 rounded-none table text-center !text-lg text-white transition-colors w-full"
              v-bind:disabled="!hasAvailableProducts(currentYear + '.' + currentWeek)"
              v-if="products && sessionStore.user.role !== 'user'"
              v-on:click="submit"
    >
        {{ __('Rendelés leadása következő hétre') }}
    </c-button>

    <c-button class="bg-transparent border-2 border-slate-800 font-semibold hover:border-highlight hover:text-highlight landscape:sm:w-96 mx-auto my-4 normal-case px-4 py-2 rounded-none table text-center !text-lg text-slate-800 transition-colors w-full" router
              v-bind:to="{ name: 'order' }"
    >
        {{ __('Új rendelés') }}
    </c-button>
</template>

<script setup lang="ts">
    import { computed, inject, onMounted, ref } from 'vue';
    import {
        CButton,
        CIcon,
    } from '@teamfurther/cinderblock';
    import { DateTime } from 'luxon';
    import OrderRepository from '../repositories/OrderRepository';
    import ProductRepository from '../repositories/ProductRepository';
    import { useCurrencyStore } from '../stores/currency';
    import { useLocalizationStore } from '../stores/localization';
    import { useRequestStore } from '../stores/request';
    import { useSessionStore } from '../stores/session';

    const __ = inject('__');
    const breakpoint = 768;
    const currencyStore = useCurrencyStore();
    const sessionStore = useSessionStore();
    const user = ref(sessionStore.user);
    const currentDate = ref(DateTime.now().setLocale('en'));
    const localizationStore = useLocalizationStore();
    const currentBreakpoint = ref(window.innerWidth);
    const currentDays = computed(() => {
        const firstDay = currentDate.value.startOf('week');

        return {
            monday: {
                date: firstDay,
                day: firstDay.day,
                month: firstDay.setLocale(localizationStore.locale).toFormat('MMM')
            },
            tuesday: {
                date: firstDay.plus({ days: 1 }),
                day: firstDay.plus({ days: 1 }).day,
                month: firstDay.plus({ days: 1 }).setLocale(localizationStore.locale).toFormat('MMM')
            },
            wednesday: {
                date: firstDay.plus({ days: 2 }),
                day: firstDay.plus({ days: 2 }).day,
                month: firstDay.plus({ days: 2 }).setLocale(localizationStore.locale).toFormat('MMM')
            },
            thursday: {
                date: firstDay.plus({ days: 3 }),
                day: firstDay.plus({ days: 3 }).day,
                month: firstDay.plus({ days: 3 }).setLocale(localizationStore.locale).toFormat('MMM')
            },
            friday: {
                date: firstDay.plus({ days: 4 }),
                day: firstDay.plus({ days: 4 }).day,
                month: firstDay.plus({ days: 4 }).setLocale(localizationStore.locale).toFormat('MMM')
            },
        }
    });
    const currentDay = computed(() => {
        return currentDate.value.ordinal;
    });
    const currentWeek = computed(() => {
        return currentDate.value.weekNumber;
    });
    const currentYear = computed(() => {
        return currentDate.value.year;
    });
    const order = ref();
    const orderRepository = new OrderRepository();
    const productRepository = new ProductRepository();
    const products = ref();
    const requestStore = useRequestStore();
    const totalPrice = computed(() => {
        let total = {
            monday: { net: 0, gross: 0 },
            tuesday: { net: 0, gross: 0 },
            wednesday: { net: 0, gross: 0 },
            thursday: { net: 0, gross: 0 },
            friday: { net: 0, gross: 0 },
        };

        products.value.forEach((product) => {
            const price = product.prices[user.value.group_id] ?? product.price_gross;

            const mondayQty = product.quantity?.[`${currentYear.value}.${currentWeek.value}`]?.['monday'] ?? 0;
            total.monday.gross += mondayQty * price;
            total.monday.net += mondayQty * price / (1 + product.vat_pct / 100);

            const tuesdayQty = product.quantity?.[`${currentYear.value}.${currentWeek.value}`]?.['tuesday'] ?? 0;
            total.tuesday.gross += tuesdayQty * price;
            total.tuesday.net += tuesdayQty * price / (1 + product.vat_pct / 100);

            const wednesdayQty = product.quantity?.[`${currentYear.value}.${currentWeek.value}`]?.['wednesday'] ?? 0;
            total.wednesday.gross += wednesdayQty * price;
            total.wednesday.net += wednesdayQty * price / (1 + product.vat_pct / 100);

            const thursdayQty = product.quantity?.[`${currentYear.value}.${currentWeek.value}`]?.['thursday'] ?? 0 * price;
            total.thursday.gross += thursdayQty * price;
            total.thursday.net += thursdayQty * price / (1 + product.vat_pct / 100);

            const fridayQty = product.quantity?.[`${currentYear.value}.${currentWeek.value}`]?.['friday'] ?? 0;
            total.friday.gross += fridayQty * price;
            total.friday.net += fridayQty * price / (1 + product.vat_pct / 100);
        });

        return total;
    });

    function addMissingQuantityData() {
        products.value.forEach((product) => {
            if (!product.quantity) {
                product.quantity = {};
            }

            if (!product.quantity[`${currentYear.value}.${currentWeek.value}`]) {
                product.quantity[`${currentYear.value}.${currentWeek.value}`] = {
                    monday: 0,
                    tuesday: 0,
                    wednesday: 0,
                    thursday: 0,
                    friday: 0,
                };
            }
        });
    }

    async function getOrder(checkPrevious = false) {
        const orders = await orderRepository.index({
            filters: {
                user_id: user.value.id,
                week: currentYear.value + '.' + currentWeek.value,
            },
            include: ['items']
        });

        order.value = orders[0];

        // If no order for current week, check if user has any past orders
        if (!order.value && checkPrevious) {
            // Get all user orders
            const allOrders = await orderRepository.index({
                filters: {
                    user_id: user.value.id,
                },
                include: ['items']
            });

            // If user has any orders, find the most recent past order
            if (allOrders.length > 0) {
                // Sort orders by year and week in descending order
                allOrders.sort((a, b) => {
                    if (a.year !== b.year) {
                        return b.year - a.year;
                    }
                    return b.week - a.week;
                });

                // Find the first past order (relative to current week)
                for (const pastOrder of allOrders) {
                    const pastWeekYear = parseInt(pastOrder.year);
                    const pastWeekNum = parseInt(pastOrder.week);
                    const currentWeekYear = parseInt(currentYear.value);
                    const currentWeekNum = parseInt(currentWeek.value);

                    if (pastWeekYear < currentWeekYear || 
                        (pastWeekYear === currentWeekYear && pastWeekNum < currentWeekNum)) {
                        // Found a past order
                        order.value = pastOrder;

                        // Update current date to match the past order's week
                        currentDate.value = DateTime.fromObject({
                            weekYear: pastWeekYear,
                            weekNumber: pastWeekNum,
                            weekday: 1
                        });

                        // Make sure quantity data is initialized for the past order's week
                        addMissingQuantityData();

                        break;
                    }
                }
            }
        }

        if (order.value && order.value.items.length > 0) {
            order.value.items.forEach((item) => {
                products.value.forEach((product) => {
                    if (product.id === item.product_id) {
                        if (!product.quantity[order.value.year + '.' + order.value.week]) {
                            product.quantity[order.value.year + '.' + order.value.week] = {};
                        }

                        product.quantity[order.value.year + '.' + order.value.week][item.day] = item.quantity;
                    }
                });
            });
        }
    }

    async function getProducts() {
        products.value = await productRepository.index({
            filters: {
                active: true,
            },
        });

        addMissingQuantityData();
    }

    function hasAvailableProducts(week) {
        let found = false;

        products.value.forEach(product => {
            if (showProduct(product, week)) {
                found = true;
            }
        });

        return found;
    }

    function jumpToDay(direction, { sameWeekOnly = false } = {}) {
        const days = [
            { key: 'monday', weekday: 1 },
            { key: 'tuesday', weekday: 2 },
            { key: 'wednesday', weekday: 3 },
            { key: 'thursday', weekday: 4 },
            { key: 'friday', weekday: 5 },
        ];

        const itemsByDay = order.value?.items_by_day || {};
        const currentWeekday = currentDate.value.weekday;

        // Base order: prev = Fri→Mon, next = Mon→Fri
        let ordered = direction === 'previous' ? [...days].reverse() : days;

        if (sameWeekOnly) {
            // Only look *before* or *after* the current day
            ordered = ordered.filter(day =>
                direction === 'previous'
                    ? day.weekday < currentWeekday
                    : day.weekday > currentWeekday
            );
        }

        for (const day of ordered) {
            const items = itemsByDay[day.key];
            const hasItems = Array.isArray(items) ? items.length > 0 : !!items;

            if (hasItems) {
                currentDate.value = currentDate.value.set({ weekday: day.weekday });
                return true; // we jumped somewhere
            }
        }

        return false; // no suitable day found
    }


    async function nextOrder() {
        if (breakpoint >= currentBreakpoint.value) {
            const jumpedInSameWeek = jumpToDay('next', { sameWeekOnly: true });

            if (jumpedInSameWeek) {
                return;
            }
        }

        if (!order.value.next_order || (order.value?.next_order.year == DateTime.now().weekYear && order.value?.next_order.week == DateTime.now().weekNumber)) {
            return;
        }

        currentDate.value = DateTime.fromObject({
            weekYear: parseInt(order.value.next_order.year, 10),
            weekNumber: parseInt(order.value.next_order.week, 10),
            weekday: 1
        });

        addMissingQuantityData();
        await getOrder();

        jumpToDay('next');
    }


    async function prevOrder() {
        if (breakpoint >= currentBreakpoint.value) {
            const jumpedInSameWeek = jumpToDay('previous', {sameWeekOnly: true});

            if (jumpedInSameWeek) {
                return;
            }
        }

        if (!order.value.previous_order) {
            return;
        }

        currentDate.value = DateTime.fromObject({
            weekYear: parseInt(order.value.previous_order.year),
            weekNumber: parseInt(order.value.previous_order.week),
            weekday: 1
        });

        addMissingQuantityData();
        await getOrder();

        jumpToDay('previous');
    }

    function showProduct(product, week) {
        return product.quantity[`${week}`].monday > 0
            || product.quantity[`${week}`].tuesday > 0
            || product.quantity[`${week}`].wednesday > 0
            || product.quantity[`${week}`].thursday > 0
            || product.quantity[`${week}`].friday > 0;
    }

    async function submit() {
        alert(__('A rendelt mennyiségek a termékek elérhetőségének függvényében változhatnak. Kérjük ellenőrízze rendelését a az oldal frissítése után.'));

        new Promise((resolve, reject) => {
            requestStore.post('orders/reorder', {
                order_id: order.value.id,
                week: currentYear.value + '.' + currentWeek.value
            }).then((response : any) => {
                requestStore.redirect({ name: 'order', query: {
                    week: DateTime.now().setLocale('en').plus({ days: 7 }).year + '.' + DateTime.now().setLocale('en').plus({ days: 7 }).weekNumber
                } }, {
                    message: __('Rendelés sikeresen létrehozva.'),
                    status: 200,
                    title: __('Siker')
                });
            }).catch(error => reject(error));
        });
    }

    onMounted(async () => {
        await getProducts();

        window.addEventListener('resize', () => {
            currentBreakpoint.value = window.innerWidth;
        });

        if (currentDate.value.weekday === 6) {
            currentDate.value = currentDate.value.plus({ day: 2 });
        } else if (currentDate.value.weekday === 7) {
            currentDate.value = currentDate.value.plus({ day: 1 });
        }

        await getOrder(true);

        jumpToDay('next');
    });
</script>
